module.exports = __webpack_public_path__ + "assets/img/100108.63e12bec.png";